module.exports = __webpack_public_path__ + "static/media/icon_home_appliances_electronics_product.9f566ebf.svg";